import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { FaTwitter, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { FaComments } from "react-icons/fa";

const Footer = () => {
  return (
    <>
      {/* FOOTER */}
      <footer className="church-footer text-light pt-5 pb-3">
        <div className="container">
          <div className="row align-items-start gy-4">

            {/* LOGO */}
            <div className="col-md-4 text-center text-md-start">
              <img
                src="/images/logo.png"
                alt="Gospel City Church Logo"
                className="footer-logo mb-3"
              />
            </div>

            {/* IMPORTANT LINKS */}
            <div className="col-6 col-md-4">
              <h6 className="footer-title">Important Links</h6>
              <ul className="list-unstyled footer-links">
                <li><Link to="https://dashboard.gcc-inter.org">Login Now</Link></li>
                <li><Link to="/who-we-are">What we are</Link></li>
                <li><Link to="/church-services">Services</Link></li>
                <li><Link to="/ministry">Ministry</Link></li>
                <li><Link to="/gallery">Gallery</Link></li>
                <li><Link to="/join">Join Us</Link></li>
              </ul>
            </div>

            {/* CONTACT US */}
            <div className="col-6 col-md-4">
              <h6 className="footer-title">Contact Us</h6>
              <p className="mb-1 footer-contact-item">IMO: (+256) 783 359 816</p>
              <p className="mb-1 footer-contact-item">Email: gospelcitychurchinter@gmail.com</p>
              <p className="mb-1 footer-contact-item">Address: Naguru Go-down</p>
              <p className="mb-0 footer-contact-item">Call: (+256) 775 028 569</p>
            </div>

          </div>

          <hr className="footer-divider my-4" />

          {/* BOTTOM ROW */}
          <div className="row align-items-center gy-3">

            {/* Copyright */}
            <div className="col-12 col-md-6 text-center text-md-start small footer-copy">
              © 2025 Gospel-City Church. ALL Rights Reserved
            </div>

            {/* Privacy + Social icons */}
            <div className="col-12 col-md-6">
              <div className="footer-bottom-right">
                <Link to="/privacy" className="footer-policy">
                  Privacy Policy
                </Link>
                <div className="social-icons">
                 <a href="https://groups.imo.im/.5l9akqTOrYa5Tv4T4" target="_blank" rel="noopener noreferrer">
                <FaComments />
                </a>
                  <a href="https://x.com/GospelCityChur?t=x8dsFbFkghmYh02lV0FVxQ&s=03" target="_blank" rel="noopener noreferrer">
                    <FaTwitter />
                  </a>
                  <a href="https://whatsapp.com/channel/0029Vb769UyDzgTBAZZcb40F" target="_blank" rel="noopener noreferrer">
                    <FaWhatsapp />
                  </a>
                  <a href="https://youtube.com/@gospelcitychurchinternational?si=1pZx2ak4ss3b4HuU" target="_blank" rel="noopener noreferrer">
                    <FaYoutube />
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </footer>

      <style>{`
        .church-footer {
          background: linear-gradient(135deg, #020024, #0b0b3b, #020024);
          letter-spacing: 0.3px;
        }

        .footer-logo {
          width: 120px;
        }

        .footer-title {
          font-weight: 600;
          margin-bottom: 14px;
          letter-spacing: 0.6px;
        }

        .footer-links li {
          margin-bottom: 8px;
        }

        .footer-links a,
        .footer-links a:visited {
          color: #dcdcdc;
          text-decoration: none;
          font-size: 14px;
          letter-spacing: 0.4px;
        }

        .footer-links a:hover { color: #ffffff; }

        .footer-contact-item {
          font-size: 13px;
          color: #dcdcdc;
          line-height: 1.7;
        }

        .footer-divider {
          border-color: rgba(255,255,255,0.2);
        }

        .footer-copy {
          letter-spacing: 0.4px;
        }

        /* bottom right row: flex, centered on mobile */
        .footer-bottom-right {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 18px;
          flex-wrap: wrap;
        }

        .footer-policy {
          color: #dcdcdc;
          text-decoration: none;
          font-size: 14px;
          letter-spacing: 0.4px;
        }

        .footer-policy:hover { color: #ffffff; }

        .social-icons {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .social-icons a {
          color: #dcdcdc;
          font-size: 18px;
          transition: color 0.2s, transform 0.2s;
          display: flex;
          align-items: center;
        }

        .social-icons a:hover {
          color: #ffffff;
          transform: translateY(-2px);
        }

        /* ── MOBILE ──────────────────────────────────── */
        @media (max-width: 576px) {

          /* logo centered, bigger tap area */
          .church-footer .col-md-4.text-center {
            text-align: center !important;
          }

          .footer-logo {
            width: 100px;
          }

          /* links & contact sit side by side in two columns */
          .footer-title {
            font-size: 13px;
            margin-bottom: 10px;
          }

          .footer-links a,
          .footer-contact-item {
            font-size: 12.5px;
          }

          /* bottom bar stacks cleanly */
          .footer-bottom-right {
            justify-content: center;
            gap: 14px;
          }

          .footer-copy {
            text-align: center !important;
            font-size: 12px;
          }

          /* bigger social icon tap targets */
          .social-icons a {
            font-size: 20px;
            padding: 4px;
          }

          /* tighten section padding */
          .church-footer {
            padding-top: 36px !important;
          }
        }

        /* md: align bottom-right to the right */
        @media (min-width: 768px) {
          .footer-bottom-right {
            justify-content: flex-end;
          }
        }
      `}</style>
    </>
  );
};

export default Footer;